var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10.125H12.375L13.125 7.125H10.5V5.625C10.5 4.85297 10.5 4.125 12 4.125H13.125V1.60508C12.8807 1.57264 11.9573 1.5 10.9822 1.5C8.9463 1.5 7.5 2.74264 7.5 5.02478V7.125H5.25V10.125H7.5V16.5H10.5V10.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbSmall);
export default __webpack_public_path__ + "static/media/fb_small.9df26100841944409b0acb82245a2032.svg";
export { ForwardRef as ReactComponent };